export const contact = {
  title: 'Contact Us',
  subtitle: 'Have questions or requests? Feel free to contact us',
  
  // Form Labels
  name: 'Name',
  namePlaceholder: 'Enter your name',
  
  email: 'Email Address',
  emailPlaceholder: 'your.email@example.com',
  
  message: 'Message',
  messagePlaceholder: 'Enter your message',
  messageLimit: 'Maximum 1000 characters',
  
  // Submit
  submitButton: 'Submit',
  submittingButton: 'Submitting...',
  
  // Messages
  successMessage: 'Your inquiry has been received. We will contact you shortly.',
  errorMessage: 'An error occurred. Please try again.',
  fillRequired: 'Please fill in all required fields',
  messageTooLong: 'Message must be 1000 characters or less'
};
